<template>
  <div class="mx-5 md:mx-0 mb-20">
    <h1 class="text-3xl uppercase my-20" :class="fontThin()">{{ $t('contacts.title') }}</h1>
    <section :aria-label="$t('contacts.title')">
      <div v-for="showroom in showrooms" :key="showroom.id" class="mt-12">
        <h2 class="font-medium border-b-2 md:w-1/3 w-2/3 border-b2c-red-300 text-xl mb-4">{{ showroom.name }}</h2>
        <h3 class="text-lg mb-1" :class="fontThin()">{{ showroom.address }}</h3>
        <h3> <strong>{{ $t('contacts.opening-hours') }}</strong> {{ showroom.opening_hours }}</h3>
        <h3><strong>{{ $t('contacts.showroomPhone') }}</strong> {{ showroom.phone }}</h3>
        <h3><strong>{{ $t('contacts.showroomEmail') }}</strong> {{ showroom.email }}</h3>
      </div>
    </section>

    <section aria-label="Send a message">
      <h2 class="text-2xl uppercase mt-32 mb-10 text-center" :class="fontThin()">{{ $t('contacts.contactUs') }}</h2>
      <form id="contact-us" :aria-label="$t('contacts.contactUs')" class="mb-10">
        <div class="flex justify-between items-center">
          <material-input class="w-1/2" :name="$t('contacts.firstname')" :showMessage="showMessages" v-model="form.firstname" />
          <span class="text-2xl pt-4">*</span>
          <material-input class="w-1/2 ml-4" :name="$t('contacts.lastname')" :showMessage="showMessages" v-model="form.lastname" />
          <span class="text-2xl pt-4">*</span>
        </div>
        <div class="flex justify-between items-center mt-8">
          <material-input class="w-1/2" :name="$t('contacts.email')" :showMessage="showMessages" v-model="form.email" />
          <span class="text-2xl pt-4">*</span>
          <material-input class="w-1/2 ml-4" :name="$t('contacts.phone')" v-model="form.phone" />
        </div>
        <textarea rows="10" :placeholder="$t('contacts.message')" :aria-label="$t('contacts.message')" v-model="form.message" class="w-full outline-none border border-gray-300 mt-12" />
        <span v-if="showMessages && form.message===''" class="italic text-b2c-red-300 text-sm">{{$t('input.fillField')}}</span>
      </form>
      <div class="flex justify-center mb-20">
        <button @click="sendMessage" :class="isLoading ? 'loader' : ''"
          class="px-4 py-2 bg-b2c-red-300 text-white hover:text-b2c-red-300 hover:bg-white border border-b2c-red-300 rounded">
            {{ $t('contacts.send') }}
        </button>
      </div>

    </section>
  </div>
</template>

<script>
import MaterialInput from '@/components/blocks/MaterialInput.vue';
import { mapGetters } from 'vuex';
import axios from 'axios';

export default {
  metaInfo() {
    const description = this.$t('metaDescriptions.contacts');
    return {
      meta: [
        {
          name: 'description',
          content: description,
        },
      ],
    };
  },

  data() {
    return {
      showrooms: [],

      form: {
        firstname: '',
        lastname: '',
        email: '',
        phone: '',
        message: '',
      },

      isLoading: false,

      showMessages: false,
    };
  },

  watch: {
    authenticated() {
      this.form.firstname = '';
      this.form.lastname = '';
      this.form.email = '';
      if (this.authenticated) {
        this.form.firstname = this.user.firstname;
        this.form.lastname = this.user.lastname;
        this.form.email = this.user.email;
      }
    },

    changedLocale() {
      this.getShowrooms();
    },
  },

  components: {
    MaterialInput,
  },

  created() {
    this.getShowrooms();
  },

  mounted() {
    if (this.authenticated) {
      this.form.firstname = this.user.firstname;
      this.form.lastname = this.user.lastname;
      this.form.email = this.user.email;
    }
  },

  computed: {
    ...mapGetters({
      authenticated: 'auth/authenticated',
      user: 'auth/user',
      changedLocale: 'auth/changedLocale',
    }),
  },

  methods: {
    getShowrooms() {
      axios.get('/api/showrooms').then((response) => {
        this.showrooms = response.data;
      }).catch(() => {
        this.createNotification('error', `${this.$t('notifications.errorTryAgain')}`);
      });
    },

    sendMessage() {
      if (this.checkData()) {
        this.isLoading = true;
        axios.post('/api/contact', this.form).then(() => {
          this.createNotification('success', `${this.$t('notifications.contact')}`);
          this.form.message = '';
          this.isLoading = false;
        }).catch(() => {
          this.isLoading = false;
          this.createNotification('error', `${this.$t('notifications.errorTryAgain')}`);
        });
        return;
      }
      this.showMessages = true;
    },

    checkData() {
      let ok = true;
      if (this.form.firstname === '' || this.form.lastname === '' || this.form.email === '' || this.form.message === '') {
        ok = false;
      }
      return ok;
    },
  },
};
</script>

<style lang="scss" scoped>
.loader {
  color: transparent !important;
  pointer-events: none;
  position: relative;
}

.loader:after {
  animation: spinAround 500ms infinite linear;
  border: 2px solid #dbdbdb;
  border-radius: 290486px;
  border-right-color: transparent;
  border-top-color: transparent;
  content: "";
  display: block;
  width: 1em;
  height: 1em;
  position: absolute;
  left: calc(50% - (1em / 2));
  top: calc(50% - (1em / 2));
}

@keyframes spinAround {
  from {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(359deg);
    transform: rotate(359deg);
  }
}
</style>
